"use strict";
import {findAll, findIn, addClass, removeClass} from "@elements/dom-utils"
import {initInScope,onFind} from "@elements/init-modules-in-scope";
import loadScript from '@elements/load-script';
import {registerPermissionGrantedCallback} from "@elements/cookie-permissions";


const defaultSelectors = {
    base: '.js-3d-room-plan',
};

export function init ( selectors = defaultSelectors) {
    registerPermissionGrantedCallback('3dplanner', function () {
        onFind(selectors.base, function (baseElement) {
            addClass('d-none', findIn('.js-3d-room-plan__overlay', baseElement));
            loadScript("https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js").then(() => {
                let script = baseElement.dataset.script;
                loadScript(script).catch(console.error);
            })
        });
    });

}